import { UtilityMethods } from "@mindmemobile/mm-shared-global";
import { PaymentTransactionStatus } from "../enums";
import { IAPIRelatedPaymentsGridModel } from "../interfaces"; 
import { PaymentMethodModel } from "./PaymentMethodModels";

export class RelatedPaymentsGridModel {
    id: string;
    amount: number;
    isRefund: boolean;
    success: boolean;
    status: keyof typeof PaymentTransactionStatus;
    description: string;
    createdDate: Date;
    paymentMethod?: PaymentMethodModel;
    totalRefunded: number;
    constructor(data: Partial<RelatedPaymentsGridModel> = {}) {
        this.id = data.id || '';
        this.amount = data.amount || 0;
        this.isRefund = data.isRefund || false;
        this.success = data.success || false;
        this.status = data.status || PaymentTransactionStatus.Failed;
        this.description = data.description || '';
        this.createdDate = data.createdDate || new Date();
        this.paymentMethod = data.paymentMethod && new PaymentMethodModel(data.paymentMethod);
        this.totalRefunded = data.totalRefunded || 0;
    }

    static deserializeAPIModel(data: IAPIRelatedPaymentsGridModel): RelatedPaymentsGridModel {
        const mappedData: Partial<RelatedPaymentsGridModel> = {
            id: data.id,
            amount: data.amount,
            isRefund: data.isRefund,
            success: data.success,
            description: data.description,
            createdDate: UtilityMethods.removeZFromDateString(data.createdDate),
            paymentMethod: data.paymentMethod && PaymentMethodModel.deserializeAPIModel(data.paymentMethod),
            totalRefunded: data.totalRefunded,
        };

        if (data.isRefund) {
            mappedData.status = data.success ? 'Refund' : 'Failed';
        } else {
            mappedData.status = data.status;
        }

        return new RelatedPaymentsGridModel(mappedData);
    }
}
